import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MapChart from './components/MapChart.tsx';
import MapChartEdit from './components/MapChartEdit.tsx'; // Import edit mode component
import { Map } from 'lucide-react';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-gray-100">
        <main className="flex-1">
          <div className="max-w-full">
            {/* Define the routes */}
            <Routes>
              {/* Default map view */}
              <Route path="/" element={<MapChart />} />
              
              {/* Edit mode view */}
              <Route path="/edit" element={<MapChartEdit />} />
            </Routes>
          </div>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
